import '../base';
import RESOURCES from './resources.data';

// import './resources.scss';

function memberDate(res) {
  if (res.date != '') {
    return '<em>' + res.date + '</em>';
  }
  return '';
}

function resourcesHtml(res) {
  let joined_refs = '';
  for (let ref of res.refs) {
    let href = ref.href;
    if (href.substring(0, 4) != 'http') {
      href = '/' + href;
    }
    joined_refs += '[<a class="link-sytle" href="' + href + '">' + ref.text + '</a>] ';
  }
  return joined_refs;
}

function titleHtml(res) {
  let title_refs = '';
  title_refs += '<a class="link-sytle" href="' + res.link + '">' + res.title + '</a> ';
  return title_refs;
}

document.addEventListener('DOMContentLoaded', function onLoaded() {
  document.removeEventListener('DOMContentLoaded', onLoaded);

  const sidemenu = document.getElementById('svl-resources--sidemenu');
  for (const group of RESOURCES.groups) {
    const liEl = document.createElement('li')
    liEl.innerHTML = `
      <a href="#${group.name.replace(/([\W-])/g, '').toLowerCase()}">${group.name}</a>
    `;
    sidemenu.appendChild(liEl);
  }

  const content = document.getElementById('svl-resources--content');
  for (const group of RESOURCES.groups) {
    const parentEl = document.createElement('div');
    const titleEl = document.createElement('p');
    titleEl.classList.add('title', 'is-4');
    titleEl.id = group.name.replace(/([\W-])/g, '').toLowerCase();
    titleEl.innerText = group.name;
    parentEl.appendChild(titleEl);
    for (const member of group.members) {
      const articleEl = document.createElement('article');
      articleEl.classList.add('columns');
      articleEl.innerHTML = `
        <div class="column is-one-quarter">
          <figure class="image is-5by4">
            <img src="${member.img}">
          </figure>
        </div>
        <div class="column">
          <p class="title is-6">${member.name}</p>
          ${titleHtml(member)}
          <p>${memberDate(member)} ${member.venue} ${member.authorsText}</p>
          ${resourcesHtml(member)}
        </div>
      `;
      parentEl.appendChild(articleEl);
    }
    content.appendChild(parentEl);
  }
});
